<template>
  <v-app>
    <core-app-bar-nat>
      <core-sub-app-bar />
    </core-app-bar-nat>

    <core-drawer />
    <core-view />
    <core-footer />
    <core-float-buttons />
    <mensaje-sitio />
    <gtm-injector :id="'GTM-WWGMCC2W'" />
  </v-app>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'Index',

    components: {
      CoreDrawer: () => import('@/components/web/core/Drawer'),
      CoreFooter: () => import('@/components/web/core/FooterCetec'),
      CoreAppBarNat: () => import('@/components/web/core/AppBarNat'),
      CoreSubAppBar: () => import('@/components/web/core/SubAppBar'),
      CoreView: () => import('@/components/web/core/View'),
      CoreFloatButtons: () => import('@/components/web/core/FloatButtons'),
      MensajeSitio: () => import('@/components/web/core/MensajeSitio'),
      GtmInjector: () => import('@/components/web/core/GtmInjector'),
    },
    created () {
      this.getSucursales()
      this.getNoticiasHome()
      this.getTestimonios()
      this.getEspecialidadesMenu()
      this.getServiciosMenu()
      this.getProblemasTiposMenu()
      this.getCharlasMenu()
      this.getSlidersPrincipal()
      this.getSlidersBienvenidos()
      this.getMensajeSitio()
      this.getCldVersion()
      this.getHorasOnlineVersion()
    // this.print()
    },
    methods: {
      ...mapActions('web', [
        'getSucursales',
        'getNoticiasHome',
        'getTestimonios',
        'getEspecialidadesMenu',
        'getServiciosMenu',
        'getProblemasTiposMenu',
        'getCharlasMenu',
        'getSlidersPrincipal',
        'getSlidersBienvenidos',
        'getMensajeSitio',
        'getCldVersion',
        'getHorasOnlineVersion',
      ]),
      print () {
        console.log('print')
      },
    },
    metaInfo: {
      link: [{ rel: 'canonical', href: 'https://www.terapia.cl/' }],
    },
  }
</script>
